module.exports = __webpack_public_path__ + "img/25.d7d07d37.svg";